import { get, post } from "../services/HttpService";
import { axiosIns } from "../services";
import { emailValidationRegex, beneficiaryNameRegex, phoneNumberValidationRegex } from "../app_methods";

export class SmartCollectTransactionOrders {
    constructor(txnObject = {}) {
        this.set(txnObject);
    };

    
    static validations = {
        "customer_name": [
            { required: true, message: "Name is required." },
            { pattern: beneficiaryNameRegex(), message: "Please enter valid Name" },
            { max:255, message: "Name can be of 255 characters." }
        ],
      
        "customer_email": [
            { pattern: emailValidationRegex(), message: "Please enter a valid Email ID." }
        ],
        "customer_phone": [
            { required: true, message: "Phone is required." },
            { pattern: phoneNumberValidationRegex(), message: "Enter valid 10 digit mobile number." }
        ],
        "amount": [
            { required: true, message: "Amount is required." },
            {
                pattern: new RegExp(/^\d+(\.\d{1,2})?$/),
                message: "Please enter a valid amount upto 2 decimal places.",
            },
        ],
        "per_transaction_amount": [
            {
                pattern: new RegExp(/^\d+(\.\d{1,2})?$/),
                message: "Please enter a valid amount upto 2 decimal places.",
            },
        ],
        "unique_request_number": [
            { required: true, message: "Unique request number is required." },
            { pattern: '^[A-Za-z0-9-]+$', message: "Please enter a valid Unique request number." },
            { max: 32, message: "Can be of maximum 32 characters" }
        ],
        "payment_type": [
            { required: true, message: "Payment type is required." },
        ],
        "expiry_date": "",
        "transaction_note": [{max: 255, message:"Can be of maximum 255 characters"}
    ],
        "udf1": [{ pattern: '^[^<>]*$', message: "Invalid UDF1" },
                {max: 255, message:"Can be of maximum 255 characters"}
    ],
        "udf2": [{ pattern: '^[^<>]*$', message: "Invalid UDF2" },
        {max: 255, message:"Can be of maximum 255 characters"}
    ],
        "udf3": [{ pattern: '^[^<>]*$', message: "Invalid UDF3" },
        {max: 255, message:"Can be of maximum 255 characters"}
    ],
        "udf4": [{ pattern: '^[^<>]*$', message: "Invalid UDF4" },
        {max: 255, message:"Can be of maximum 255 characters"}
    ],
        "udf5": [{ pattern: '^[^<>]*$', message: "Invalid UDF5" },
        {max: 255, message:"Can be of maximum 255 characters"}
    ],
        "notification_cycle_type":[],
        "allowed_collection_modes": [{ required: true, message: "Select atleast one." }],
        "soundbox_ids": [
            {pattern: '^[a-zA-Z0-9]{6}$', message: "Only alphanumeric values are allowed" },
            {max: 6, message:"Can be of maximum 6 characters"}
    ],
    };

    static list = (queryData = {}, config = {}) => {
        return get(`v1/insta-collect/internal/orders/`, queryData, config).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }));
    };

    static list_v2 = (queryData = {}, config = {}) => {
        return get(`v2/insta-collect/internal/orders/`, queryData, config).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }));
    };

    static fetchOrder = (id, queryData = {}) => {
        return get(`v1/insta-collect/internal/orders/${id}/retrieve`, queryData).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }));
    };

    /**
     * @memberof SmartCollectTransactionOrders
     * @type API
     * @returns Promise
     */
    save = () => {
        let queryData = this.get();
        return post(`v1/insta-collect/internal/orders/`, queryData, {}).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
    };


    static editOrderApiCall = (orderId,data) => {
        let queryData = data
        return post(`v1/insta-collect/internal/orders/${orderId}/`, queryData, {}).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
    };

    static generate_order_urn = (queryData = {}, config = {}) => {
        return post(`v1/insta-collect/internal/orders/generate_order_urn/`, queryData, config);
    }
    static notify_customer = (queryData = {}, config = {}) => {
        return post(`v1/insta-collect/internal/orders/${queryData.id}/notify/`, queryData, config);
    }
    cancel = (queryData = {}, config = {}) => {
        return post(`v1/insta-collect/internal/orders/${this.id}/cancel/`, queryData, config);
    }

    retrigger_webhook = (queryData = {}, config = {}) => {
        return get(`v1/insta-collect/internal/orders/${this.id}/retrigger_webhook/`, queryData, config);
    }    
    
    update_status = (queryData = {}, config = {}) => {
        return get(`v1/insta-collect/internal/orders/${queryData.id}/update_status/`, queryData, config);
    }    
    
    static report_download = (queryData = {}, config = {}) => {
        return axiosIns.request({
            url: 'v1/insta-collect/internal/orders/report_download/',
            method: 'POST',
            responseType: 'blob',
            data: queryData,
            headers: config.headers
        }).catch(error => ({ success: false, data: "Something went wrong", status: 500 }))
    }
    
    get = () => {
        return {
            id: this.id,
            amount: this.amount,
            unique_request_number: this.unique_request_number,
            customer_name: this.customer_name,
            customer_email: this.customer_email,
            customer_phone: this.customer_phone,
            per_transaction_amount: this.per_transaction_amount,
            notification_cycle_type:this.notification_cycle_type,
            notify_customer_on_create:this.notify_customer_on_create,
            expiry_date: this.expiry_date,
            // dqr_soundbox: this.dqr_soundbox,
            dqr_soundbox: false,
            udf1: this.udf1,
            udf2: this.udf2,
            udf3: this.udf3,
            udf4: this.udf4,
            udf5: this.udf5,
            allowed_collection_modes: this.allowed_collection_modes,
            allowed_payment_modes: this.allowed_payment_modes,
            soundbox_ids: this.soundbox_ids,
            transaction_note: this.transaction_note
        }
    };

    /**
     * @memberof SmartCollectTransactionOrders
     * @type Setter Method
     * @takes SmartCollectTransactionOrders Params
     * @returns void
     */
     set = (values) => {
        Object.keys(values).forEach((x) => (this[x] = values[x]));
    };

}